import { styled } from '../../shared/theming-sc/'
import {
  switchVisibility,
  textOverflowEllipsis
} from '../../shared/utilities/styleUtils'
import { CELL_HEIGHT } from './config'

const cellHeight = `${CELL_HEIGHT}px`

const baseStyles = `
  color: #4d4d4d;
  font-size: 15px;
  line-height: 1;
  -webkit-tap-highlight-color: transparent;
  font-family: 'Knowledge2017';
  strong{
    font-weight: 500;
  }
`

export const StyledOuterDiv = styled.div.attrs({
  style: ({useBreakout}) => ({ display: useBreakout ? 'block' : 'inline-block' })
})`
  position: relative;
  width: 100%;
  border-radius: 8px;
`

export const StyledMain = styled.div.attrs({
  style: ({height, isOpen, isTickAfterOpen}) => {
    return {
      height: `${height}px`,
      boxShadow: (isOpen && isTickAfterOpen) ? '5px 5px 4px rgba(0,0,0,0.2)' : '0 0 0 rgba(0,0,0,0)',
      transition: `height ${isOpen ? 0.5 : 0.25}s cubic-bezier(0.5,0.85,0,1), box-shadow 0.2s`
    }
  }
})`
  ${baseStyles};
  box-shadow: 0px 0px 0px rgba(0,0,0,0.2);
  position: relative; left:0; top:0;
  background: #fff;
  width: 100%;
  height: ${cellHeight};
  min-width: 200px;
  overflow: hidden;
  border: 1px solid #dddddd;
  border-radius: 5px;
`
export const StyledHeader = styled.div`
  position: relative;
  width: calc(100% - 30px);
  height: ${cellHeight};
`
export const StyledLabel = styled.div.attrs({
  style: ({ visible }) => switchVisibility({ visible, timeScale: visible ? 0.75 : 1 })
})`
  position: absolute; left:0; top:0;
  padding: 22px 20px;
  width: 100%;
  ${textOverflowEllipsis}
  cursor: pointer;
  opacity: 1;
  &:hover{
    opacity: 0.65;
  }
`

export const StyledScrollbarHider = styled.div.attrs({
  style: ({ isVisible }) => {
    return {
      opacity: isVisible ? 1 : 0,
      visibility: isVisible ? 'visible' : 'hidden',
      background: isVisible ? 'transparent' : '#fff'
    }
  }
})`
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 60px;
  width: 24px;
  height: calc(100% - ${cellHeight});
  background: #fff;
  transition: opacity 0.5s, visibility 0.5s;
`
